
import CardAdd from "../../../assets/filled/CardAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardAddIcon({ className, dataTestid = "CardAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
